export default "__VITE_ASSET__e6a58804__"